<template>
  <div>
    <ModuleList />
  </div>
</template>

<script>
import ModuleList from '@/components/ModuleList.vue';

export default {
  components: {
    ModuleList,
  },
};
</script>

